const VIEWPORT_GAP = 16;
const MOBILE_VIEWPORT_GAP = 40;
const TOOLTIP_MAX_WIDTH = 200;
const TOOLTIP_OFFSET = 10;
const TRIANGLE_WIDTH = 20;

const getViewportGap = () => (window.innerWidth < 768 ? MOBILE_VIEWPORT_GAP : VIEWPORT_GAP);

class ProductSubscriptionInfo extends HTMLElement {
  static get observedAttributes() {
    return ['data-active'];
  }

  constructor() {
    super();

    this.tooltip = null;
    this.reposition = this.reposition.bind(this);
  }

  connectedCallback() {
    this.tooltip = this.querySelector('.main-product__subscriptions-about');

    window.addEventListener('resize', this.reposition);
    window.addEventListener('scroll', this.reposition, true);

    if (this.dataset.active === 'true') {
      requestAnimationFrame(this.reposition);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.reposition);
    window.removeEventListener('scroll', this.reposition, true);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name !== 'data-active' || oldValue === newValue) return;

    if (newValue === 'true') {
      requestAnimationFrame(this.reposition);
      return;
    }

    this.resetPosition();
  }

  resetPosition() {
    if (!this.tooltip) return;

    this.tooltip.style.position = '';
    this.tooltip.style.left = '';
    this.tooltip.style.top = '';
    this.tooltip.style.bottom = '';
    this.tooltip.style.maxWidth = '';
    this.tooltip.style.removeProperty('--subscription-about-triangle-left');
  }

  reposition() {
    if (!this.tooltip || this.dataset.active !== 'true') return;

    const anchorRect = this.getBoundingClientRect();
    const viewportGap = getViewportGap();

    this.tooltip.style.position = 'fixed';
    this.tooltip.style.left = '0px';
    this.tooltip.style.top = '0px';
    this.tooltip.style.bottom = 'auto';
    this.tooltip.style.maxWidth = `min(${TOOLTIP_MAX_WIDTH}px, calc(100vw - ${viewportGap * 2}px))`;

    const tooltipRect = this.tooltip.getBoundingClientRect();
    const availableRight = window.innerWidth - viewportGap;
    const availableBottom = window.innerHeight - viewportGap;
    const preferredTop = this.classList.contains('position-top')
      ? anchorRect.top - tooltipRect.height - TOOLTIP_OFFSET
      : anchorRect.bottom + TOOLTIP_OFFSET;

    const left = Math.min(
      availableRight - tooltipRect.width,
      Math.max(viewportGap, anchorRect.left)
    );
    const top = Math.min(
      availableBottom - tooltipRect.height,
      Math.max(viewportGap, preferredTop)
    );
    const triangleLeft = Math.min(
      tooltipRect.width - TRIANGLE_WIDTH,
      Math.max(0, anchorRect.left + (anchorRect.width / 2) - left - (TRIANGLE_WIDTH / 2))
    );

    this.tooltip.style.left = `${left}px`;
    this.tooltip.style.top = `${top}px`;
    this.tooltip.style.setProperty('--subscription-about-triangle-left', `${triangleLeft}px`);
  }
}

if (!customElements.get('product-subscription-info')) {
  customElements.define('product-subscription-info', ProductSubscriptionInfo);
}
